<template>
  <div>
    <b-navbar toggleable="lg" class="top p-0">
      <!-- <a href="https://www.google.com/calendar/render?action=TEMPLATE&text=%C3%98redev&dates=20201104T070000Z%2F20201106T153000Z&details=For%20details%2C%20see%20https%3A%2F%2Fwww.oredev.org.%0A&location=Malm%C3%B6M%C3%A4ssan%20Exhibition%20%26%20Congress%20Center&sf=true&output=xml" target="_blank" class="next">
    Save the date: <span class="date">November 4–6, 2020</span>
      </a>-->
      <b-navbar-brand class="p-3">
        <router-link to="/">
          <svg
            style="width: 180px"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 122 22.3"
            enable-background
            class="text-light"
          >
            <g>
              <path
                fill="black"
                d="M53.2
                  2.6c-1.2.1-2 .1-2.5.7l-1.8 2.5h9.1l-1.1 1.6h-9.1s-1.6 2.2-1.8 2.6c-.4.7 0 1
                  .6 1h11.8l-1.3 1.5h-10.9c-2.3 0-3.6-.4-3.9-1.3-.1-.3-.1-.7.1-1l4.7-7c.7-1.1
                  2.1-1.8 3.7-2 .9-.1 1.8-.2 2.7-.2h11l-1.3 1.5h-10zM92.2 2.6c-1.2.1-2
                  .1-2.5.7l-1.8 2.5h9.1l-1.1 1.6h-9.1s-1.6 2.2-1.8 2.6c-.4.7 0 1 .6
                  1h11.8l-1.3 1.5h-10.9c-2.3 0-3.6-.4-3.9-1.3-.1-.3-.1-.7.1-1l4.7-7c.7-1.1
                  2.1-1.8 3.7-2 .9-.1 1.8-.2 2.7-.2h11l-1.3 1.5h-10zM77.9 10.4c-.7 1.4-2.7
                  2.1-5.9 2.1h-11.8l7.9-11.4h11.1c.8 0 1.4 0 2.1.2.8.2 1.9 1 1.3 2.1-.8 1-4.7
                  7-4.7 7zm-.3-7.8h-7l-5.6 8.4h7.6c.8 0 1.4-.2 1.7-.6 0 0 4.3-6.4 4.7-7
                  .4-.7-.8-.8-1.4-.8zM108.3 9.3l10.1-8.2h3.6l-14.1 11.3h-3.2l1.3-11.3h3.4l-1.1
                  8.2zM52.2
                  20.2h-.5c-.5.2-1.8.8-4.1.2-4-.9-5.6-3.1-7.5-7.9-.9-2.1-1.6-4.2-2.7-5.1h1.4c1.2
                  0 2.2-.4 2.5-1.1.4-.7 1.7-2.9
                  1.8-3.6.1-.7-.5-1.2-1.3-1.4-.6-.2-1.3-.2-2.1-.2h-11.2l-7.5
                  11.4h3.8l3.2-5.1h4c.7 0 1.7.4 2.2 1 1.4 1.5 3.6 7.2 6.7 10.2 1.5 1.5 3.1 2.6
                  4.8 3 1.5.4 3 .5 4.4.1 1.4-.3 2.2-.8 2.3-1.3 0 0
                  0-.1-.2-.2zm-21.3-17.6h7.4c1.5 0 1.7.4 1.4.8-.3.5-1 1.5-1 1.5-.4.6-1
                  .9-1.8.9h-7.9l1.9-3.2zM26.5.2h-3.1l-1.7 1c-.4-.1-.9-.1-1.5-.1 0 0-5-.1-6.3
                  0-1.3.1-1.8.1-2.7.2-1.6.2-2.6.4-3.7 2-.8 1.2-4.7 7-4.7 7-.2.3-.2.6-.1 1
                  .1.2.2.4.4.5l-2.9 1.6h3.1l1.8-1c.4 0 1 .1 1.5.1h6.4c3.2 0 4.9-.5 5.9-2.1 0 0
                  4.4-6.8 4.5-7 .3-.6.2-1.1-.1-1.4l3.2-1.8zm-15.3 3.1c.4-.6 1.6-.7
                  2.5-.7h5.5l-12.6 7.2c.9-1.3 4.6-6.5 4.6-6.5zm4.2
                  7.1c-.3.4-.9.6-1.7.6h-6l11.9-6.8c-1.1 1.7-3.7 5.5-4.2 6.2z"
              />
            </g>
          </svg>
        </router-link>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse" class="p-3">
        <i class="material-icons text-dark"></i>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav class="text-center background">
        <div class="d-lg-none mt-5 mb-2">
          <h1 class="theme text-dark">Wondering when?</h1>
          <p class="text-uppercase text-dark">8–10 Nov 2023 - Malmö, Sweden</p>
        </div>
        <b-navbar-nav class="ml-auto">
          <b-nav-item class="b-nav-item" to="/tickets">Tickets</b-nav-item>
          <b-nav-item
            :to="{
              path: '/line-up',
              query: { tags: $route.query.tags, day: $route.query.day },
            }"
            >Line-up</b-nav-item
          >
          <b-nav-item
            :to="{
              path: '/sessions',
              query: { tags: $route.query.tags, day: $route.query.day },
            }"
            >Sessions</b-nav-item
          >
          <!--    <b-nav-item
            :to="{
              path: '/workshops',
            }"
            >Workshops</b-nav-item
          > -->
          <b-nav-item to="/info" class="mr-4 active">Info</b-nav-item>
          <!--a class="nav-item nav-link text-dark show-search-button nav-link" href="#search" data-toggle="collapse" aria-expanded="false" aria-controls="search"><i class="material-icons mobile-search">search</i></a-->
          <b-nav-item to="/my-schedule" class="position-relative">
            <i class="material-icons">calendar_today</i>
            <span class="my-count text-center position-absolute">{{
              $store.state.count
            }}</span>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "top",
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },

  data() {
    return {
      scrollPosition: "0",
      active: false,
      windowWidth: window.innerWidth,
    };
  },

  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
      if (window.scrollY > 200) {
        this.active = true;
      } else {
        this.active = false;
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },

  computed: {
    test() {
      return this.$store.dispatch("incrementAsync");
    },
    isMobile() {
      if (this.windowWidth <= 576) {
        return true;
      }
      return false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/variables.scss";
.background {
  background: url(https://res.cloudinary.com/oredev/image/upload/f_autoq_65/v1556784443/2019/html/background-start-2.jpg);
}

.top {
  z-index: 99;
}
.nav-item {
  font-size: 18px;
  line-height: 33px;
  color: $text-dark !important;
}
.next {
  position: absolute;
  top: -60px;
  left: 0;
  right: 0;
  font-size: 1.1rem;
  height: 60px;
  background: black;
  text-align: center;
  text-decoration: underline !important;
  color: white;
  padding-top: 18px;
  &:hover {
    text-decoration: none !important;
  }
  .date {
    font-weight: bold;
    text-transform: uppercase;
  }
}
.material-icons {
  font-size: 35px;
}
.navbar-light .navbar-toggler .material-icons {
  font-size: 25px;
}
.navbar-light .navbar-toggler[aria-expanded="false"] .material-icons::after {
  content: "menu";
}
.navbar-light .navbar-toggler[aria-expanded="true"] .material-icons::after {
  content: "close";
}
.navbar-light .navbar-toggler {
  border: none !important;
  color: white;
  font-size: 25px;
}
h1.theme {
  font-size: 1.7rem !important;
}
.navbar-collapse a.nav-link {
  @media (max-width: 991px) {
    margin: 0;
  }
}
.navbar-collapse.show {
  padding-bottom: 2rem;
}

.my-count {
  top: 10px;
  position: absolute;
  border: 1px solid $orange;
  border-radius: 50%;
  margin: -6px 0 0 0;
  right: 15px;
  width: 30px;
  height: 30px;
  line-height: 1.6rem;
  font-size: 1.1rem;
  font-weight: normal;
  background-color: $orange !important;
  color: #fff;
  @media (max-width: 992px) {
    top: 0;
    margin-left: -15px;
    right: auto;
    left: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue